import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  base: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '90%',
  },
  infoColumn: {
    flex: 1,
  },
  titleText: {
    marginBottom: 4,
  },
  avatarColumn: {
    flex: 0,
  },
  optaviaTextContainer: {
    flexDirection: 'row',
    marginTop: indent * 0.3,
    alignItems: 'center',
  },
  idContainer: {
    flexDirection: 'row',
    paddingLeft: 8,
    alignItems: 'center',
  },
  copyIcon: {
    fontSize: 20,
    marginLeft: 4,
  },
});
